import moment from "moment";
import useFetch from "../../../hooks/useFetch";
import PaymentAction from "./PaymentAction";
import AlertError from "../../../components/ui/error/AlertError";
import TableLoading from "../../../components/ui/loader/TableLoading";

const tableHeader = [
  "Ref ID",
  "Status",
  "Amount",
  "Date",
  "Email",
  "Contact",
  "E-Receipt",
  "Further Action",
];

const PaymentList = ({ url, selected }) => {
  const { loading, data = [], error } = useFetch(url);

  if (loading) {
    return (
      <div className="mt-4 w-full px-1 py-1 bg-custom-dodger-blue-100 rounded-md overflow-x-auto relative">
        <TableLoading header={tableHeader} />
      </div>
    );
  }
  if (error) {
    return <AlertError message={error} />;
  }
  if (data?.length <= 0) {
    return (
      <div className="mt-4 w-full px-3 py-5 bg-custom-dodger-blue-100 rounded-md overflow-x-auto relative text-center">
        <span className="font-xs text-red-500">There is no data found!</span>
      </div>
    );
  }

  const itemAmount = (payment) => {
    let amount;
    if (selected.value.toLowerCase() === "all") amount = payment.amount;
    else {
      payment.items.forEach((item) => {
        if (item.name.toLowerCase() === selected.value.toLowerCase()) {
          amount = item.price;
        }
      });
    }
    return amount;
  };

  return (
    <div className="mt-4 w-full px-1 py-1 bg-custom-dodger-blue-100 rounded-xl overflow-x-auto relative mb-20 ">
      <table className="w-full border-separate border-spacing-2">
        <thead className="text-xs capitalize text-left">
          <tr>
            {tableHeader.map((th) => (
              <th key={th} scope="col" className="font-normal text-xs">
                {th}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-xs capitalize text-left">
          {data?.map((payment) => (
            <tr key={payment._id} className="row space-x-3">
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md flex items-center gap-x-2.5">
                {payment.referenceId}
                {payment.items.length > 1 && (
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                )}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                {payment.status}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                $ {itemAmount(payment)}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md min-w-[135px]">
                {moment(payment.date).format("YYYY-MM-DD h:mm A")}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md lowercase">
                {payment.email}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                {payment?.contactNumber}
              </td>
              <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                {payment.receipt}
              </td>
              <td className="font-normal text-xs bg-white rounded-md">
                <PaymentAction payment={payment} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentList;
